import { RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard.component';
import { AuthGuard } from '@app/auth/auth.guard';
import { Roles } from '@models/roles';
import { CommunicationViewerComponent } from './communication-viewer/communication-viewer.component';
import { NotificationLogViewerComponent } from './notification-log-viewer/notification-log-viewer.component';
var ɵ0 = {
    roles: [Roles.admin, Roles.candidate]
}, ɵ1 = {
    roles: [Roles.admin, Roles.candidate]
};
var routes = [
    {
        path: 'communication-viewer',
        component: CommunicationViewerComponent,
        canLoad: [AuthGuard],
        data: ɵ0
    },
    {
        path: 'notification-log-viewer',
        component: NotificationLogViewerComponent,
        canLoad: [AuthGuard],
        data: ɵ1
    },
    {
        path: '',
        component: DashboardComponent,
        canActivate: [AuthGuard]
    }
];
export var DashboardRoutes = RouterModule.forChild(routes);
export { ɵ0, ɵ1 };
